// The Six HUMAN+ Pillars — definitions provided by the client.
// Slugs are stable and used as identifiers across the app.

export const PILLARS = [
    {
        slug: "human-awareness",
        number: "01",
        name: "Human Awareness",
        short: "Conscious experience of self, others, and environment.",
        definition:
            "Human Awareness is the state in which information about one's internal states, thoughts, emotions, bodily sensations, and external environment is consciously experienced, meaningfully interpreted, and accessible for reflection and voluntary regulation.",
        outcomes: [
            "Sharper executive judgment",
            "Reduced reactivity under pressure",
            "Higher psychological capital",
        ],
    },
    {
        slug: "understanding-others",
        number: "02",
        name: "Understanding Others",
        short: "Reading people, perspectives, and unspoken cues.",
        definition:
            "Understanding Others is the capacity to accurately infer, interpret, and respond to other people's emotions, thoughts, intentions, and perspectives through verbal and nonverbal cues and situational context, integrating empathy and social cognition to guide effective interpersonal behavior.",
        outcomes: [
            "Stronger client relationships",
            "Lower team friction",
            "Higher trust across functions",
        ],
    },
    {
        slug: "mindset-for-adaptability",
        number: "03",
        name: "Mindset for Adaptability",
        short: "A learning posture that flexes with change.",
        definition:
            "Mindset for Adaptability is a way of thinking that combines a belief in one's capacity to learn and change with a willingness to adjust thoughts, emotions, and behaviors in response to new, uncertain, or changing situations.",
        outcomes: [
            "Faster response to market shifts",
            "Resilience through change",
            "Continuous capability growth",
        ],
    },
    {
        slug: "ai-partnership",
        number: "04",
        name: "AI Partnership",
        short: "Humans and AI working together — with judgment intact.",
        definition:
            "AI Partnership is a collaborative arrangement in which humans and artificial intelligence systems deliberately combine their complementary capabilities — human judgment, values, and contextual understanding with AI's speed, pattern detection, and scalability — to achieve outcomes that neither could reliably accomplish alone while maintaining human oversight and responsibility.",
        outcomes: [
            "Responsible AI adoption",
            "Productivity without judgment loss",
            "Clear human accountability",
        ],
    },
    {
        slug: "navigating-transformation",
        number: "05",
        name: "Navigating Transformation",
        short: "Reshaping the organization while supporting people.",
        definition:
            "Navigating Transformation is the capacity of individuals and organizations to continuously reshape strategies, structures, and ways of working in response to shifting conditions, while actively supporting people's engagement, well-being, psychological safety, and potential to flourish.",
        outcomes: [
            "Smoother organizational change",
            "Protected employee well-being",
            "Higher change adoption rates",
        ],
    },
    {
        slug: "human-flourishing",
        number: "06",
        name: "Human Flourishing",
        short: "Conditions for meaning, growth, and sustained performance.",
        definition:
            "Human Flourishing is the ability of individuals and organizations to create the conditions that support sustained well-being, meaningful work, positive relationships, personal growth, purpose, engagement, and optimal performance in an AI-enabled world.",
        outcomes: [
            "Higher engagement and retention",
            "Meaning-driven performance",
            "Healthier organizational culture",
        ],
    },
];

export const FRAMEWORK_BENEFITS = [
    {
        title: "Research-Informed",
        body: "Grounded in published research on psychology, organizational development, and responsible AI adoption.",
    },
    {
        title: "Executive-Ready",
        body: "Designed to be acted on by CEOs, HR leaders, and senior teams — not just discussed in workshops.",
    },
    {
        title: "Human + AI, Not Either/Or",
        body: "Equips your people to work with AI without losing the judgment, empathy, and meaning only humans bring.",
    },
    {
        title: "Practical & Measurable",
        body: "Each pillar translates to behaviors, capabilities, and outcomes you can actually move on a scorecard.",
    },
];

export const BUSINESS_OUTCOMES = [
    "Responsible, confident AI adoption across the organization",
    "Higher leadership effectiveness during transformation",
    "Lower attrition and stronger employee engagement",
    "Faster team adaptation to new tools and ways of working",
    "Clearer organizational direction in an AI-enabled market",
    "A workforce that flourishes — not just functions",
];
